import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const SellerDashboard = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('mitoforge_token');
    const role = localStorage.getItem('mitoforge_role');
    
    if (!token || role !== 'seller') {
      navigate('/login');
      return;
    }

    fetch('/api/seller/dashboard', {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(resData => {
        if (resData.message) throw new Error(resData.message);
        setData(resData);
      })
      .catch(err => setError(err.message));
  }, [navigate]);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  if (error) return <div style={{ color: 'red', textAlign: 'center', marginTop: '100px' }}>{error}</div>;
  if (!data) return <div style={{ color: '#fff', textAlign: 'center', marginTop: '100px' }}>Loading dashboard...</div>;

  return (
    <div style={{ minHeight: '100vh', background: '#000', color: '#fff', paddingTop: '100px', paddingBottom: '60px' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '0 20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '40px' }}>
          <h1 style={{ mragin: 0 }}>Seller Dashboard</h1>
          <button onClick={handleLogout} style={{ background: '#333', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer' }}>Logout</button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', marginBottom: '40px' }}>
          <div style={{ background: '#111', padding: '24px', borderRadius: '8px', border: '1px solid #333' }}>
            <div style={{ color: '#888', fontSize: '0.9rem', marginBottom: '8px' }}>Your Affiliate Code</div>
            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#fff' }}>{data.affiliateCode}</div>
            <div style={{ fontSize: '0.8rem', color: '#666', marginTop: '8px' }}>Customers get this tracked at checkout</div>
          </div>
          <div style={{ background: '#111', padding: '24px', borderRadius: '8px', border: '1px solid #333' }}>
            <div style={{ color: '#888', fontSize: '0.9rem', marginBottom: '8px' }}>Total Earned Commission</div>
            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#4caf50' }}>₹{data.totalCommission.toFixed(2)}</div>
            <div style={{ fontSize: '0.8rem', color: '#666', marginTop: '8px' }}>From {data.orders.length} total orders</div>
          </div>
        </div>

        <h3 style={{ marginBottom: '16px', borderBottom: '1px solid #333', paddingBottom: '8px' }}>Referred Orders</h3>
        {data.orders.length === 0 ? (
          <p style={{ color: '#888' }}>No orders have used your code yet.</p>
        ) : (
          <div style={{ background: '#111', borderRadius: '8px', border: '1px solid #333', overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
              <thead>
                <tr style={{ background: '#1a1a1a', borderBottom: '1px solid #333' }}>
                  <th style={{ padding: '12px 16px', color: '#888', fontWeight: 'normal', fontSize: '0.9rem' }}>Date</th>
                  <th style={{ padding: '12px 16px', color: '#888', fontWeight: 'normal', fontSize: '0.9rem' }}>Order ID</th>
                  <th style={{ padding: '12px 16px', color: '#888', fontWeight: 'normal', fontSize: '0.9rem' }}>Order Total</th>
                  <th style={{ padding: '12px 16px', color: '#888', fontWeight: 'normal', fontSize: '0.9rem' }}>Your Commission (10%)</th>
                </tr>
              </thead>
              <tbody>
                {data.orders.map(order => (
                  <tr key={order.id} style={{ borderBottom: '1px solid #222' }}>
                    <td style={{ padding: '12px 16px' }}>{new Date(order.created_at).toLocaleDateString()}</td>
                    <td style={{ padding: '12px 16px', fontFamily: 'monospace' }}>{order.order_id}</td>
                    <td style={{ padding: '12px 16px' }}>{order.currency} {order.total_amount}</td>
                    <td style={{ padding: '12px 16px', color: '#4caf50' }}>₹{order.commission_amount.toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default SellerDashboard;
